<template>
  <div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('dashboard')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
      </inertia-link>
    </div>

    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('vendas')">
        <icon name="sale" class="w-4 h-4 mr-2" :class="isUrl('vendas') ? 'text-white' : 'text-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('vendas') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Vendas</div>
      </inertia-link>
    </div>

    <div v-if="$page.props.auth.user.nivel == 'a'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('especificacoes')">
        <icon name="list" class="w-4 h-4 mr-2" :class="isUrl('especificacoes') ? 'text-white' : 'text-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('especificacoes') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Especificações</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.nivel == 'a'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('users')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Usuários</div>
      </inertia-link>
    </div>
    <!--
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('reports')">
        <icon name="printer" class="w-4 h-4 mr-2" :class="isUrl('reports') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('reports') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reports</div>
      </inertia-link>
    </div> -->
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
